import { render, staticRenderFns } from "./default.vue?vue&type=template&id=762fa133&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./treatmentStepTwoTables.styles.scss?vue&type=style&index=0&id=762fa133&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762fa133",
  null
  
)

export default component.exports